import { COMMON_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { usePermissions } from '../../authentication';

export const useIsTracerPermitted = () => {
    const isConfigured = useConfigMatch(
        {},
        {
            [COMMON_FLAGS.ENABLED_OPEN_TELEMETRY_UI]: 'true',
        }
    );

    const isPermitted = usePermissions('UI_TRACING');

    return isConfigured && isPermitted;
};
